import { StrictMode } from 'react';
import '@rainbow-me/rainbowkit/styles.css';
import App from 'app/app';
import { createRoot } from 'react-dom/client';
import 'i18n/i18n';
import '../styles/tailwind.css';

const container = document.querySelector('#root');

if (container) {
  const root = createRoot(container);

  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
